
import { Users, Clock, Navigation } from "lucide-react";
import { formatDuration, getTripType } from "@/utils/tripFormatUtils";

interface TripCardDetailsProps {
  passenger_count: number;
  booking_duration: string | number;
  is_round_trip?: boolean;
  isCompleted: boolean;
  onViewMoreClick: () => void;
}

const TripCardDetails = ({ 
  passenger_count, 
  booking_duration, 
  is_round_trip, 
  isCompleted,
  onViewMoreClick
}: TripCardDetailsProps) => {
  const formattedDuration = formatDuration(booking_duration);
  const tripType = getTripType(is_round_trip);
  
  return (
    <div className="flex justify-between mb-4">
      <div className={`flex items-center gap-1 ${isCompleted ? 'text-white' : 'text-black'} text-xs`}>
        <Users size={14} />
        <span>{passenger_count} guests</span>
      </div>
      <div className={`flex items-center gap-1 ${isCompleted ? 'text-white' : 'text-black'} text-xs`}>
        <Clock size={14} />
        <span>{formattedDuration}</span>
      </div>
      <div className={`flex items-center gap-1 ${isCompleted ? 'text-white' : 'text-black'} text-xs`}>
        <Navigation size={14} />
        <span>{tripType}</span>
      </div>
      <button 
        className={`text-xs ${isCompleted ? 'bg-white text-black' : 'bg-neon-green text-black'} px-2 py-0.5 rounded-full`}
        onClick={onViewMoreClick}
      >
        More Info
      </button>
    </div>
  );
};

export default TripCardDetails;
